import React, { useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router";
import { useState } from "react";
import Header from "../home/header";
import PaymentItem from "./payment_item";
import UTILS from "../../utils/commons";
import { ApiClient } from "../../utils/api-client";

import Loading from "../home/Loading";
import PaginationControl from "../home/pagination_control";
import { AxiosError } from "axios";

const Payments = props => {
    var navigate = useNavigate();
    var loginState = JSON.parse( window.sessionStorage.getItem( "loginState" ) );
    const apiClient = new ApiClient( loginState ? loginState.accessToken : null );
    const [ payments, setPayments ] = useState( [] );
    const [ filteredData, setFilteredData ] = useState( payments );
    const [ loading, setLoading ] = useState( false );
    const [ currentPage, setCurrentPage ] = useState( 1 );
    const [ pageSize, setPageSize ] = useState( 10 );
    const [ totalPages, setTotalPages ] = useState( 1 );
    const [ hasNextPage, setHasNextPage ] = useState( false );
    const [ hasPreviousPage, setHasPreviousPage ] = useState( false );
    const [ filterBy, setFilterBy ] = useState( "all" );
    const [managers, setManagers] = useState( [] );
    const canCreatePayment = loginState?.role === UTILS.FINANCE || loginState?.role === UTILS.ADMIN || loginState?.role === UTILS.SALES;

    const search = ( e ) => {
        let keyword = e.target.value.trim().toLowerCase();
        let result = payments;
        if ( keyword.length > 0 ) {
            result = payments.filter( d =>
                UTILS.paymentType( d?.type || 0 ).toLowerCase().includes( keyword ) ||
                String( d?.amount || '' ).toLowerCase().includes( keyword ) ||
                ( d?.customer?.name || '' ).toLowerCase().includes( keyword ) ||
                ( d?.profile?.firstName || '' ).toLowerCase().includes( keyword ) ||
                ( d?.profile?.lastName || '' ).toLowerCase().includes( keyword ) ||
                UTILS.formatDate( d?.createdAt || '' ).toLowerCase().includes( keyword )
            );
        }
        setFilteredData( result );
    }
    const handlePageChange = ( newPage ) => {
        setCurrentPage( newPage );
        loadData(newPage, pageSize,filterBy);
    }
    const handlePageSizeChange = ( newPageSize ) => {
        setPageSize( newPageSize );
        setCurrentPage( 1 );
        loadData( 1, newPageSize, filterBy );
    }
    const loadData = async (page=currentPage, limit=pageSize,filter = filterBy) => {
        setLoading( true );
        let endpoint = "/payments/paginated";
        const params = { page: page, limit: limit };
        if ( filter !== 'all' && ( loginState.role === UTILS.FINANCE || loginState.role === UTILS.ADMIN ) ) {
            params.profileId = filter;
        }
        else if ( loginState.role == UTILS.ADMIN ) params.ownerId = loginState.id;
        else if ( loginState.role == UTILS.FINANCE ) {
            // params.profileId = loginState.profile.id;
            params.ownerId = loginState.profile.ownerId
        }
        else params.profileId = loginState.profile.id;
        try {
            const response = await apiClient.get( endpoint, { params: params } );
            if ( response.status === 200 && response.data ) {
                setPayments( response.data.data );
                setFilteredData( response.data.data );
                setTotalPages( response.data.totalPages );
                setHasNextPage( response.data.hasNextPage );
                setHasPreviousPage( response.data.hasPreviousPage );
            }
            else if ( response.status === 401 ) {
                UTILS.signout();
                navigate( '/signin', { replace: true, target: '/payments' } );
            }
        }
        catch ( error ) {
            if ( error instanceof AxiosError && error.response && error.response.status === 401 ) {
                UTILS.signout();
                navigate( '/signin', { replace: true, target: '/payments' } );
            }
        }
        setLoading( false );

    }
    const handleFilter = (e) => {
            let value = e.target.value;
            setFilterBy( value );
            loadData( 1, pageSize, value );
        }
        const getManagers = async () => {
            try {
                const response = await apiClient.get( "/managers/list" );
                setManagers( response.data );
            }
            catch ( e ) {
                console.log( "Error fetching managers", e );
                if ( e instanceof AxiosError && e.status === 401 ) {
                    UTILS.signout();
                    navigate( '/signin', { replace: true, target: '/payments' } );
                }
            }
        }
    
    useEffect( () => {
        loadData(currentPage, pageSize, filterBy);
        if(loginState.role === UTILS.ADMIN || loginState.role === UTILS.FINANCE) getManagers();
    }, [] )
    if ( loginState ) {
        return ( <>
            <Header auth={loginState} />
            <section className="flex justify-start items-start">
                <div className="container">
                    <div className="rounded-xl border border-gray-200 bg-gradient-to-r from-white to-gray-50 p-4 md:p-5">
                        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
                            <div>
                                <p className="text-sm uppercase tracking-wide text-gray-500">Finance</p>
                                <p className="text-2xl font-semibold text-gray-800">Payments</p>
                            </div>
                            <div className="w-full md:w-auto flex flex-col md:flex-row gap-3">
                                <input className="w-full md:w-80 px-3 py-2 focus:outline-none rounded-md border border-gray-300 focus:ring-2 focus:ring-gray-300" type="text" placeholder="Search payments..." onChange={search} />
                                {canCreatePayment ? <button className="btn bg-success md:min-w-[7rem]" onClick={() => navigate( "/payments/new", { replace: false } )}>Add Payment</button> : null}
                            </div>
                        </div>
                    </div>
                    {loading ? ( <Loading className="mx-auto mt-16" /> ) : (
                        <div className="mt-12">
                            <div className="md:flex justify-between items-center mb-4">
                                {loginState?.role !== UTILS.SALES ? <select value={filterBy} onChange={handleFilter} className="px-3 py-1 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gray-300">
                                    <option value="all">All Managers</option>
                                    {managers.map( m => <option key={m.id} value={m.id}>{m.firstName} {m.lastName}</option> )}
                                </select> : <span></span>}
                                <PaginationControl pageSize={pageSize} currentPage={currentPage} totalPages={totalPages} onPageChange={handlePageChange} onPageSizeChange={handlePageSizeChange} hasNextPage={hasNextPage} hasPreviousPage={hasPreviousPage} />
                            </div>
                            <div className="border border-gray-200 rounded-lg overflow-hidden pt-0 grid md:grid-cols-1 gap-0 md:justify-start md:items-center flex-wrap" id="list_container">
                                <div className="grid md:grid-cols-6 bg-gray-100 p-3 font-semibold text-gray-700 ">
                                    <span>Date</span>
                                    <span>Category</span>
                                    <span>Amount</span>
                                    <span>Received From</span>
                                    <span>Paid To</span>
                                    <span className="text-center">Recorded By</span>
                                </div>
                                {filteredData && filteredData.length > 0 ? filteredData.map( ( r, i ) => {
                                    return <PaymentItem data={r} key={r.id} source={payments} className={`${( 1 + i ) % 2 === 0 ? 'bg-gray-100' : 'bg-white'}`} />
                                } ) : <span className="text-center w-full py-8 text-gray-500">No data</span>
                                }
                            </div>
                        </div>
                    )}</div>

            </section>
        </> )
    }

}
export default Payments;